import axios from "axios";
// Verificar se está em localhost
const hostname = window.location.hostname;

let baseURL;

if(hostname.startsWith("192.168.")){
  baseURL = `http://${hostname}/conecta-dados/api/`;
} else if (hostname === "localhost" || hostname === "127.0.0.1") {
  baseURL = "http://localhost:1000/api/";
} else if (hostname.includes("dev") || hostname.includes("staging")) {
  baseURL = "https://dados-staging.conectavenda.com.br/api/";
} else if (hostname === "bs-local.com") {
  baseURL =  "http://bs-local.com/conecta-dados/api/";
} else {
  baseURL = "https://dados.conectavenda.com.br/api/";
}

const api = axios.create({
  baseURL: baseURL,
  withCredentials: !!baseURL.includes("https"),
  headers: {
    "Content-Type": "application/json"
  },
});

let conectaSession: string | null = sessionStorage.getItem("conecta-session");

api.interceptors.request.use((cfg) => {
  if (conectaSession) {
    cfg.headers["conecta-session"] = conectaSession;
  }
  return cfg;
});

api.interceptors.response.use((res) => {
  const sid = res.headers["conecta-session"];
  if (sid) {
    conectaSession = sid;
    sessionStorage.setItem("conecta-session", sid);
  }
  return res;
});

export { api, baseURL, hostname };

